import { Button, Col, Empty, Result, Skeleton, Typography } from "antd";
import Header from "components/layout/Header";
import { FormattedMessage } from "react-intl";

import {
  useBillingDescription,
  useOrderDescription,
  useOrderDetails,
  useRefundModal,
  useRefundTable,
  useTicketTable,
} from "./hooks";
import OrderDescription from "./partials/OrderDescription";
import TicketTable from "./partials/TicketTable";
import BillingDescription from "./partials/BillingDescription";
import * as Styled from "./styles";
import RefundTable from "./partials/RefundTable";
import RefundModal from "./partials/RefundModal";

const OrderDetails: React.FC = () => {
  const { order, loading, error } = useOrderDetails();
  const orderDescription = useOrderDescription();
  const billingDescription = useBillingDescription();
  const ticketTable = useTicketTable();
  const refundTable = useRefundTable();
  const refundModal = useRefundModal();

  if (loading) {
    return <Skeleton paragraph={{ rows: 10 }} />;
  }

  if (error) {
    return (
      <Result
        status="error"
        title={<FormattedMessage defaultMessage="Something went wrong" />}
        subTitle={error.message}
      />
    );
  }

  if (!error && !loading && !order) {
    return <Empty />;
  }

  return (
    <>
      <Header>
        <Col>
          <Typography.Title>
            <FormattedMessage
              defaultMessage="Order: {orderNumber}"
              values={{ orderNumber: order?.orderNumber }}
            />
          </Typography.Title>
        </Col>
        <Col>
          <Button type="primary" block onClick={refundModal.openModal}>
            <FormattedMessage defaultMessage="Issue Refund" />
          </Button>
        </Col>
      </Header>
      <Styled.OrderSection>
        <OrderDescription {...orderDescription} />
      </Styled.OrderSection>
      <Styled.OrderSection>
        <Typography.Title>
          <FormattedMessage defaultMessage="Ticket Information" />
        </Typography.Title>
        <TicketTable {...ticketTable} />
      </Styled.OrderSection>
      <Styled.OrderSection>
        <Typography.Title>
          <FormattedMessage defaultMessage="Buyer Information" />
        </Typography.Title>
        <BillingDescription {...billingDescription} />
      </Styled.OrderSection>
      <Styled.OrderSection>
        <Typography.Title>
          <FormattedMessage defaultMessage="Refund Information" />
        </Typography.Title>
        <RefundTable {...refundTable} />
      </Styled.OrderSection>
      <RefundModal {...refundModal} />
    </>
  );
};

export default OrderDetails;
